import React, { useState, useEffect, useRef } from 'react';

import { Link, useLocation } from 'react-router-dom';
import { menus } from '../../data/menu.js';
import { useScroll } from '../../hook/useScroll.js';

import styles from './header.module.css';

const Header = ({ isTrans, preFetch, type }) => {
  const mobileMenuRef = useRef();
  const menuRef = useRef([]);

  const { scrollY } = useScroll();

  const [activeMenu, setActiveMenu] = useState(null);
  const [showMobileMenu, setMobileMenu] = useState(false);

  const onMenuSelect = (index) => {
    setActiveMenu((old) => (old !== null && old === index ? null : index));
  };

  const [current, setCurrent] = useState(null);
  const location = useLocation();
  const { pathname } = location;

  const makeRequest = (page) => {
    try {
      window.makeRequest(page);
    } catch (error) {
      console.log(error);
    }
  };

  /* const goToSmartStore = (e) => {
    e.preventDefault();

    try {
      makeRequest('/smartstore');
    } catch (error) {
      console.log(error);
    }
    window.open('https://smartstore.naver.com/unospay', '_blank');
  }; */

  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      function onLogSubmit(type) {
        if (!wcs_add) var wcs_add = {};
        wcs_add['wa'] = 's_5a30d46ee013';

        var _nasa = {};
        if (window.wcs) {
          _nasa['cnv'] = wcs.cnv('4', type);

          wcs.inflow('unospay.com');
          wcs_do(_nasa);
        }
      };
      
      function makeRequest(page) {
        try {
            AM_PL(page);
          } catch (e) {console.log(e)} 
      };
    `;

    script.type = 'text/javascript';
    script.async = 'async';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!location || !mobileMenuRef.current) return;
    if (location.pathname === current) return;

    mobileMenuRef.current.checked = false;
    setActiveMenu(false);
    setMobileMenu(false);

    setCurrent(location);
  }, [location, current]);

  useEffect(() => {
    /* Prevent scrolling when menu opened */
    if (showMobileMenu) {
      document.body.style.overflow = 'hidden';
      return;
    }

    document.body.style.overflow = 'unset';
  }, [showMobileMenu]);

  useEffect(() => {
    const handleClick = (e) => {
      if (
        menuRef?.current &&
        !menuRef.current.find((subMenu) => subMenu.contains(e.target) === true)
      ) {
        setActiveMenu(null);
      }
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [menuRef]);

  return (
    <header
      className={`${styles.header} ${
        showMobileMenu ? styles.whiteHeader : ''
      } ${isTrans && scrollY < 140 ? styles.header_transprent : null}`}
    >
      <div className={styles.headerBox}>
        <div className={styles.logo}>
          <Link to={'/'}>
            <img
              src={process.env.PUBLIC_URL + `/imgs/UNOS.png`}
              alt='우노스로고'
            />
          </Link>
        </div>

        {type !== 'simple' ? (
          <>
            <nav className={styles.navContainer}>
              <ul
                className={`${showMobileMenu ? styles.mobilNavList : ''} ${
                  styles.navList
                }`}
              >
                {menus.map((menu, index) => {
                  let { title, url, children } = menu;
                  return (
                    <li
                      key={title}
                      ref={(el) => (menuRef.current[index] = el)}
                      className={
                        activeMenu === index
                          ? [styles.menuBox, styles.activeMenu].join(' ')
                          : styles.menuBox
                      }
                    >
                      <div
                        className={styles.menu}
                        onClick={() => onMenuSelect(index)}
                      >
                        {title}
                        <span className={styles.expandIcon}>
                          {activeMenu === index ? '-' : '+'}
                        </span>
                      </div>

                      {children && (
                        <ul className={styles.subMenuBox}>
                          {children.map((subMenu, i) => {
                            let fullUrl = `/${url}/${subMenu.url}`;

                            return subMenu.isExternal ? (
                              <a
                                key={i}
                                href={subMenu.url}
                                target='_blank'
                                rel='noreferrer'
                              >
                                <li className={styles.subMenu}>
                                  {subMenu.title}
                                </li>
                              </a>
                            ) : (
                              <Link
                                key={i}
                                to={fullUrl}
                                onMouseOver={() => preFetch(fullUrl)}
                                onMouseDown={() => makeRequest(fullUrl)}
                              >
                                <li
                                  className={`${styles.subMenu} ${
                                    pathname === fullUrl
                                      ? styles.activeSubMenu
                                      : ''
                                  }`}
                                >
                                  {subMenu.title}{' '}
                                  <span className={styles.arrow} />
                                </li>
                              </Link>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                })}

                <li
                  ref={(el) => (menuRef.current[5] = el)}
                  className={styles.menuBox}
                >
                  <Link onClick={() => onMenuSelect(5)} to={'hardware/others'}>
                    <div className={`${styles.menu} ${styles.textBlue}`}>
                      담배자판기
                    </div>
                  </Link>
                </li>

                {/* 스마트스토어 */}
                {/* <li
                  className={`${styles.menuBox} ${styles.externalMenu}`}
                  onClick={goToSmartStore}
                >
                  <div className={styles.menu}>
                    스마트 스토어 바로가기
                    <span className={styles.menuArrowIcon} />
                  </div>
                </li> */}
              </ul>
            </nav>

            <div className={styles.externalBtns}>
              {/* <div className={[styles.externalBtn, styles.bgTrans].join(' ')}>
                <a
                  href='https://smartstore.naver.com/unospay'
                  target='_blank'
                  rel='noopener noreferrer'
                  onClick={goToSmartStore}
                >
                  스마트 스토어
                </a>
              </div> */}

              <li
                ref={(el) => (menuRef.current[6] = el)}
                className={
                  activeMenu === 6
                    ? [styles.askBtn, styles.activeMenu].join(' ')
                    : styles.askBtn
                }
              >
                <a href='https://www.beaverstorelab.com/contact?utm_source=unospay&utm_medium=internal&utm_campaign=contact'>
                  <div className={styles.menuTitle}>상담 신청</div>
                </a>

                {/* <ul className={`${styles.subMenuBox} ${styles.askSubMenuBox}`}>
                  <li
                    onClick={() => onTypeformClick('header')}
                    className={styles.subMenu}
                  >
                    <TypeSlide>온라인 신청</TypeSlide>
                  </li>

                  <li
                    onClick={() => onKakaoClick('header')}
                    className={styles.subMenu}
                  >
                    카카오톡 신청
                  </li>
                </ul> */}
              </li>

              <div className={styles.mobileMenuIcon}>
                <input
                  ref={mobileMenuRef}
                  type='checkbox'
                  id='toggle'
                  className={styles.toggleInput}
                  onChange={(e) => setMobileMenu(e.target.checked)}
                />
                <label htmlFor='toggle' className={styles.hamburger}>
                  <div className={styles.top}></div>
                  <div className={styles.middle}></div>
                  <div className={styles.bottom}></div>
                </label>
              </div>
            </div>
          </>
        ) : (
          <div className={styles.btnBox}>
            <Link to={'/'}>
              <div className={styles.simpleBtn}>홈페이지 바로가기</div>
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
